import React from 'react';
import { Grid, Typography } from '@material-ui/core';

const TITLE_STYLE = {
  fontSize: 27,
  letterSpacing: '0.1em',
  fontFamily: 'Montserrat',
};

const firstName = name => name?.toUpperCase().split(' ')[0] || '';

export default function CollectionTitle({ profile, selectedUser, seasonName }) {
  const owner = selectedUser ? selectedUser.name : profile?.name;
  return (
    <Grid style={{ marginTop: -8, marginBottom: 12 }}>
      <Typography align="center" style={TITLE_STYLE}>
        {firstName(owner)}
        &apos;S{' '}
        <Typography
          display="inline"
          style={{ ...TITLE_STYLE, fontWeight: 'bold' }}
        >
          {seasonName}
        </Typography>{' '}
        COLLECTION
      </Typography>
    </Grid>
  );
}
